import { MobileDiscoveryResponse } from '../../types/UserDiscoveryResponse.types';
import { Criteria } from '../../../models/Criteria';
import { api } from '../../../index';

export const getCriterias = async (origin: string): Promise<MobileDiscoveryResponse | Criteria[]> => {
  return await api.get<MobileDiscoveryResponse | Criteria[]>(`/${origin}`);
};
